module.exports = __webpack_public_path__ + "img/training-example.d4cd6dca.svg";